// Референсные картинки — третий канал ряда входов, рядом с кадрами и элементами.
// Нативный Kling Omni принимает их отдельным полем (`refer_image` в `contents[]`),
// и это единственное, чем режим отличается от «Кадры → Видео» в промпт-баре.
//
// Канал объявлен моделью, но исполнить его может не всякий маршрут: нужен
// адаптер с `IMAGE_REFERENCE`, и он же должен покрывать остальные заполненные
// каналы одним запросом. Недоступный канал рисуется неактивным и прямо говорит
// почему — показать возможность, которой у нашего маршрута нет, честнее, чем
// принять картинку, которая молча никуда не уедет. Причину считает
// `prompt-channel-gates`, слот только показывает.
//
// Ролей у канала нет: референсы — пул до `maxReferenceImages`, и порядок в нём
// значения не имеет (модель связывает их с промптом по упоминанию, не по месту).
// Поэтому рисуются набранные плитки плюс одна кнопка добавления, а не решётка
// пустых слотов: у Seedance лимит доходит до девяти, и пустая решётка заняла бы
// бар целиком, ничего не сообщая.

import { useTranslation } from "react-i18next";

import { MediaChannelSlots } from "./MediaChannelSlots";

import type { PendingUpload } from "~/shared/store/types";

export interface ReferenceSlotsProps {
    /** Сколько референсов принимает режим (`mode.maxReferenceImages`). */
    maxReferences: number;
    /** Уже набранные референсы этого чата. */
    items: readonly PendingUpload[];
    disabled: boolean;
    /** Какие файлы принимает канал — тот же accept, что у кадров. */
    accept?: string;
    /** Готовая подсказка «почему недоступно»; пусто — канал доступен. */
    unavailableHint?: string;
    onPickFiles: (files: File[]) => void;
    onPickFromUploaded: () => void;
    onPickFromGenerated: () => void;
    onRemove: (localId: string) => void;
}

export function ReferenceSlots({
    maxReferences,
    items,
    disabled,
    accept,
    unavailableHint,
    onPickFiles,
    onPickFromUploaded,
    onPickFromGenerated,
    onRemove,
}: ReferenceSlotsProps) {
    const { t } = useTranslation("chat");

    return (
        <MediaChannelSlots
            max={maxReferences}
            items={items}
            disabled={disabled}
            accept={accept ?? "image/*"}
            unavailableHint={unavailableHint}
            addLabel={t("prompt.references.addSlot")}
            removeLabel={t("prompt.references.remove")}
            onPickFiles={onPickFiles}
            onPickFromUploaded={onPickFromUploaded}
            onPickFromGenerated={onPickFromGenerated}
            onRemove={onRemove}
        />
    );
}
